import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Mail } from 'lucide-react';
import { mockData } from '../data/mock';

const Team = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6" style={{ background: 'linear-gradient(180deg, #A9C9D9 0%, #FFFFFF 100%)' }}>
        <div className="max-w-7xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl md:text-7xl font-bold mb-8" style={{ color: '#1A1A1A' }}>
              The Team Behind the Mission
            </h1>
            <p className="text-xl md:text-2xl text-gray-700 max-w-4xl mx-auto">
              World-class experts in climate science, blockchain technology, and artificial intelligence
            </p>
          </motion.div>
        </div>
      </section>

      {/* Team Grid */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
            {mockData.team.map((member, index) => (
              <TeamMemberCard key={index} member={member} index={index} />
            ))}
          </div>
        </div>
      </section>

      {/* Join Section */}
      <section className="py-32 px-6" style={{ background: 'linear-gradient(135deg, #7CB8D6 0%, #A9C9D9 100%)' }}>
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-8 text-white">
              Join Our Mission
            </h2>
            <p className="text-xl text-white/90 mb-12">
              We're always looking for passionate individuals who want to make a real impact on climate action
            </p>
            <motion.button
              className="btn-premium px-12 py-6 rounded-full text-xl font-semibold"
              style={{ background: '#F4D740', color: '#1A1A1A' }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              View Open Positions
            </motion.button>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

const TeamMemberCard = ({ member, index }) => {
  return (
    <motion.div
      className="card-premium rounded-3xl bg-white border-2 border-gray-100 overflow-hidden"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
    >
      {/* Avatar */}
      <div className="aspect-square bg-gradient-to-br from-blue-100 to-yellow-100 flex items-center justify-center">
        <div className="text-6xl font-bold" style={{ color: '#7CB8D6' }}>
          {member.name.split(' ').map(n => n[0]).join('')}
        </div>
      </div>
      
      {/* Info */}
      <div className="p-8">
        <h3 className="text-2xl font-bold mb-2" style={{ color: '#1A1A1A' }}>
          {member.name}
        </h3>
        <p className="text-sm font-semibold mb-4" style={{ color: '#7CB8D6' }}>
          {member.role}
        </p>
        <p className="text-gray-600 leading-relaxed mb-6">
          {member.bio}
        </p>
        
        {/* Social Links */}
        <div className="flex gap-4">
          {member.linkedin && (
            <a
              href={member.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`linkedin-${member.name.split(' ')[0].toLowerCase()}`}
              aria-label={`${member.name} on LinkedIn`}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <Linkedin size={20} style={{ color: '#7CB8D6' }} />
            </a>
          )}
          <a
            href="mailto:info.climateco2re@gmail.com"
            aria-label={`Email ${member.name}`}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <Mail size={20} style={{ color: '#7CB8D6' }} />
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default Team;